import React from 'react';
import { Col, Row } from 'reactstrap';

interface ComponentProps {
  label: string;
  value?: string | number;
  colWidth?: number;
}

const InfoRow: React.FC<ComponentProps> = ({ label, value, colWidth = 5 }) => (
  <Row>
    <Col lg={colWidth} className="fw-bold">
      {label}
    </Col>
    <Col className="text-end">{value}</Col>
  </Row>
);

export default InfoRow;
